// ==========================
// Version 1 — utils/toast.js (event-bus style API)
// ==========================
let listeners = new Set();
let id = 0;

export function subscribe(fn) { listeners.add(fn); }
export function unsubscribe(fn) { listeners.delete(fn); }

export const toast = {
  push(message, type = 'info', opts = {}) {
    const t = { id: ++id, message, type, ...opts };
    listeners.forEach((fn) => fn(t));
  },
  success(message, opts = {}) { toast.push(message, 'success', opts); },
  error(message, opts = {}) { toast.push(message, 'error', opts); },
};
export default toast;
// ==========================
// End Version 1 — utils/toast.js
// ==========================
